import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import * as ngCommonHttp from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ChangeSetsApi } from '@constants/api';
import { AbstractChangeSetService } from '@abstract-services/change-sets/1.0/change-sets.abstract-service';
import {
  CatalogChangeForItem,
  CatalogChangesResponse,
  ChangeSetItem,
  ChangeSetsRequest,
  ChangeSetsResponse,
  ChangesListResponse,
  PatchCatalogChangesInput,
  PatchCatalogChangesResponse,
  ReleaseChangeSetResponse,
} from '@interfaces/change-sets/1.0';
import { OmitService } from '@services/utilities/1.0/omit.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeSetsService implements AbstractChangeSetService {
  allChangesUrl: any;
  cachedBrandId: string;
  serviceURL: any;
  deleteUrl: any;
  isResetting = false;
  changesUrl: any;
  patchItemURL: any;
  patchSetUrl: any;
  releaseSetUrl: any;
  reloadChangeList: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);

  constructor(private http: ngCommonHttp.HttpClient) {
    this.serviceURL = ChangeSetsApi.GET;
    this.patchItemURL = ChangeSetsApi.PATCH_ITEM;
    this.patchSetUrl = ChangeSetsApi.PATCH_SET;

    this.allChangesUrl = ChangeSetsApi.GET_ALL_CHANGES;
    this.changesUrl = ChangeSetsApi.GET_CHANGES;
    this.deleteUrl = ChangeSetsApi.DELETE;
    this.releaseSetUrl = ChangeSetsApi.RELEASE_SET;
  }

  create(body: ChangeSetsRequest): Observable<ChangeSetItem> {
    const URL = this.serviceURL;

    return this.http.post(URL, body).pipe(
      map((response: ChangeSetItem) => {
        return response;
      }),
      catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
    );
  }

  update(changeSetId: string, body: ChangeSetsRequest): Observable<ChangeSetItem> {
    const URL = this.patchSetUrl.replace('{changeSetId}', changeSetId);

    return this.http.patch(URL, body).pipe(
      map((response: ChangeSetItem) => {
        return response;
      }),
      catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
    );
  }

  delete(changeSetId: string): Observable<ChangeSetItem> {
    const URL = this.deleteUrl.replace('{changeSetId}', changeSetId);

    return this.http.delete(URL).pipe(
      map((response: ChangeSetItem) => {
        return response;
      }),
      catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
    );
  }

  get(changeSetId: string, catalogEntryId: string): Observable<CatalogChangeForItem[]> {
    // return new Observable<CatalogChangeForItem[]>((subscriber) => {
    //   subscriber.next([
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: {
    //         enabled: true,
    //         volume: 123,
    //       },
    //       targetEntityType: TargetEntityType.product,
    //       targetField: 'alcohol',
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityType: TargetEntityType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: {
    //         modifierGroupIds: ['7f4e3252-94c2-4a11-95e1-aa9a1cc2566b'],
    //         modifierGroupContextData: [
    //           {
    //             maximumQuantity: 2,
    //             minimumQuantity: 1,
    //             allowedModifications: [
    //               {
    //                 modifierId: 'defe7063-45ce-4e1c-bec1-f0e45a8df949',
    //                 instructionIds: [
    //                   'cb338fb2-ea58-4b33-a41f-1824390f54db',
    //                   '5f8241c1-ddf7-495f-97ce-5e3cb381484c',
    //                 ],
    //               },
    //               {
    //                 modifierId: '89ae2c29-adea-4f30-a840-04f23682d4ad',
    //                 instructionIds: ['cb338fb2-ea58-4b33-a41f-1824390f54db'],
    //               },
    //               {
    //                 modifierId: 'ceaec1ae-8f80-4bd4-b9ac-d98064edb2a3',
    //                 instructionIds: ['cb338fb2-ea58-4b33-a41f-1824390f54db'],
    //               },
    //               {
    //                 modifierId: 'a638b75e-9a6b-448f-9f27-7164ddc2cfbd',
    //                 instructionIds: [],
    //               },
    //               {
    //                 modifierId: '9e468c01-1aaa-4c5a-a3fd-a5c92b10d8ce',
    //                 instructionIds: [],
    //               },
    //             ],
    //             defaultModifications: [
    //               {
    //                 modifierId: 'defe7063-45ce-4e1c-bec1-f0e45a8df949',
    //                 instructionIds: ['cb338fb2-ea58-4b33-a41f-1824390f54db'],
    //               },
    //               {
    //                 modifierId: '89ae2c29-adea-4f30-a840-04f23682d4ad',
    //                 instructionIds: [],
    //               },
    //               {
    //                 modifierId: 'ceaec1ae-8f80-4bd4-b9ac-d98064edb2a3',
    //                 instructionIds: [],
    //               },
    //               {
    //                 modifierId: 'a638b75e-9a6b-448f-9f27-7164ddc2cfbd',
    //                 instructionIds: [],
    //               },
    //               {
    //                 modifierId: '9e468c01-1aaa-4c5a-a3fd-a5c92b10d8ce',
    //                 instructionIds: [],
    //               },
    //             ],
    //             modifierQuantities: [],
    //             hiddenModifiers: [],
    //             modifierGroupId: '7f4e3252-94c2-4a11-95e1-aa9a1cc2566b',
    //           },
    //         ],
    //       },
    //     },
    //     // {
    //     //   id: '',
    //     //   type: CatalogLookupType.product,
    //     //   targetEntityType: TargetEntityType.modifierGroup,
    //     //   targetEntityOperation: TargetEntityOperation.upsert,
    //     //   targetValue: {
    //     //     minimumQuantity: 2,
    //     //     maximumQuantity: 6,
    //     //     modifierIds: [
    //     //       'd5e853c1-5083-4b5f-b6a2-b21db5793075',
    //     //       '70368b9c-ba80-4b3b-be68-0e2605d159cd',
    //     //       '407c322f-1571-4cbd-984a-afdea9b5eabf',
    //     //       '170c8bbb-42c0-4435-9c0f-9646ce5c8f45',
    //     //       '24ee57d7-57ee-4a2f-8d83-ca4c4106945c',
    //     //       '626bf906-429e-44dc-a4b5-ca74d90c5101',
    //     //       '95677454-b1a9-484a-b68a-c73ae4953fd3',
    //     //       '4c81b840-0b5c-4c91-ba09-fc2d1b129d65',
    //     //       'defe7063-45ce-4e1c-bec1-f0e45a8df949',
    //     //       '89ae2c29-adea-4f30-a840-04f23682d4ad',
    //     //       '8c859c02-1b8f-4364-b686-de9bef073387',
    //     //       'ceaec1ae-8f80-4bd4-b9ac-d98064edb2a3',
    //     //       '3050b4ae-ee7f-4a59-8793-1e226efdc94d',
    //     //       'ef88da09-362b-484c-90c9-dbdf3389ec80',
    //     //       '79baf113-1f6b-427a-99cb-48b457f59a0a',
    //     //       '6c0711a5-3081-4527-b1a7-6dbb6948b6ed',
    //     //       '8918d7e8-f3be-41b9-91e1-00d7b6ec950a',
    //     //       'd3af7f16-ddfe-4f5a-8c6d-500fc341823e',
    //     //       'c5e35298-1470-4b37-a8fd-541d852c7822',
    //     //       '7ba92a84-b7f9-4b89-bf97-16d89e9f621d',
    //     //       '6ad5b5ed-4d2b-4e21-9f02-25b1642912ac',
    //     //       'ebd41e8b-5c8b-4074-870e-7df6dc5436a4',
    //     //       '6adfa13f-7992-498b-bd0f-084764b99969',
    //     //       '60dd2b30-f768-462d-9d6f-b953d432c214',
    //     //       'bf039fdb-d25a-4671-b2a3-83bc4df6df5c',
    //     //       'f37fbab1-4133-47a7-95f2-cbf9f1161af6',
    //     //       '0038a0ab-21c4-497f-a7a3-4a579637d27e',
    //     //       'ac830575-776c-4a31-bb26-bafcdf203ebc',
    //     //       'f70a30a5-d251-4479-9929-4692d64c6caf',
    //     //       'db3ceac7-29dd-44c6-8fa8-0089bc4250ee',
    //     //       'b4979a15-dbb2-4067-8274-33a52164711b',
    //     //       '284e052a-99b7-4204-97c0-2578261e699f',
    //     //       '65545eb4-1916-49ae-8969-3b55a7b39f7d',
    //     //       '8656ca84-5e74-4f87-8605-294349f607a0',
    //     //       '390f9921-3086-427b-baec-23aec7d50581',
    //     //       'fda2595a-34c2-4ba1-93b3-ee32cda751a2',
    //     //       'ea181a48-bbcb-4060-83a6-242d96eb94af',
    //     //       '7a4f69e4-5504-4d77-adb0-adc8e1cdb8e5',
    //     //       '1473f62d-79f1-48bd-a6a2-262f06f17121',
    //     //       '478df31a-e1c4-4036-aa67-056a886cc3dd',
    //     //       '26cb2430-f01e-4a86-b9e0-a2d3cf6b9ab0',
    //     //       '8557f857-0d0e-43b3-9fa3-af98aced96c9',
    //     //       '1d6866d0-c6d6-4023-a01d-f477026dbacc',
    //     //       'a9466a55-55b6-46a6-8f5a-b2624226f9a2',
    //     //       '88042b57-35cc-4fdd-9a58-2bf7eae2d13a',
    //     //       'f9ea24a0-1a1f-4f71-9045-e7bf1d4db9e3',
    //     //       '181e0d6b-2eb0-484f-8e20-ef30d7a0b7b1',
    //     //       '7bd5e67b-eda1-48c1-8127-e2231c80ff62',
    //     //       '0ccb9ed2-be07-4410-a34a-628848fed288',
    //     //       'a7ad4316-bc72-4745-bbd6-81118c07d701',
    //     //       'f56f39b1-10a0-44c3-9e78-098856b3453c',
    //     //       '246f7c84-522c-40e2-b212-03d784787435',
    //     //       'c3019004-1652-4c05-ab37-3e4850692133',
    //     //       '7ecc1270-8a77-4786-aab0-5914f3c7aa59',
    //     //       '862159c5-e07f-4be5-b6cd-b51fc3b548d4',
    //     //       '727adc29-560d-45df-9ffd-dda3cd900b52',
    //     //       'b91c2490-0190-4dd5-b8db-2f0bba168682',
    //     //       '1b8c67f1-410b-4d77-9d6b-3c41736d1ef2',
    //     //       'c76d3eb5-5cb1-4190-b684-cb6fde8c0781',
    //     //       '2e67f3df-9ff0-4442-b2ed-f9b651e46b4b',
    //     //       '335ea0bf-59ad-4411-9791-865236fe6b0e',
    //     //       'e0067257-7e23-428b-a43c-984af1eaa674',
    //     //       '935adf02-9f93-41ee-856e-104ff31e6631',
    //     //       '0b5de2fa-a2fb-40fb-aeaa-3abdeb523145',
    //     //       '2bc642d3-c443-4bf6-b9af-eb84148f94b5',
    //     //       'e6863350-e23f-4041-a8c4-5f301c0a72a2',
    //     //       '4ddb9c9b-195f-4dfc-9e25-d8eb16d720c7',
    //     //       'fced870e-84a4-4647-b2b3-65c9b377841a',
    //     //       'ec528023-bdab-47d1-a3cd-4e11e33a50ff',
    //     //       '21330786-8e1c-4531-8e91-e4256c97cc4d',
    //     //       '69170f2a-654e-455a-a3f8-389c2d759f30',
    //     //       '30c75500-2e48-4198-8cfc-d46bb6fa5c3b',
    //     //       '7533a914-9b71-4adb-83b9-6088ba84fcef',
    //     //       'fdb2766b-4852-484e-b29f-2be3dfe26c26',
    //     //       '3c432450-1660-4d11-be91-0856d32a8298',
    //     //       'a2528ab3-41f7-4561-8c49-d48e0030e758',
    //     //       'afe905d5-4ba6-48f7-a450-20449529949f',
    //     //       'f676164f-07a2-4692-818e-3ab75eea5584',
    //     //       '0e47b231-15ff-40f8-ad29-cd495f3c59ef',
    //     //       '5b93e4c3-7673-4ed1-8a65-59d12520f4b9',
    //     //       '99aa15a3-51f5-4f6f-bbe6-9582f23f0f05',
    //     //       '920d52c7-a890-4fad-97e6-5b5b9e2f2726',
    //     //       '2d6538eb-9478-49e3-bb68-bfcfec891f5d',
    //     //       '4d182c51-df21-425c-b124-60940b9c26b2',
    //     //       '15aefe9d-83e7-4128-9121-60586bef1e61',
    //     //       '0ce2e5dc-8aa8-460b-8aaa-d3cfa085fa35',
    //     //       '066b28e5-3ffc-422e-96d5-3a669966e8ef',
    //     //       'fc8fe573-ca58-47ab-a2f6-bac0719220c2',
    //     //       '2201da4b-fa65-4270-94d7-05b3393f1a3a',
    //     //       '7ee6eb86-7548-4048-9fb4-891c02ffba44',
    //     //       '85c47fc8-65da-42aa-81c1-399a88b0f4a9',
    //     //       '70959efa-5c73-4346-b966-56acac9625a9',
    //     //       '79d14f13-57da-466b-8bab-918f0150d2fa',
    //     //     ],
    //     //     modifierQuantities: [],
    //     //     hiddenModifiers: [],
    //     //   },
    //     // },
    //     // {
    //     //   id: '',
    //     //   type: CatalogLookupType.product,
    //     //   targetEntityOperation: TargetEntityOperation.upsert,
    //     //   targetEntityType: TargetEntityType.productGroup,
    //     //   targetValue: {
    //     //     minimumQuantity: 4,
    //     //     maximumQuantity: 8,
    //     //     productIds: [
    //     //       '56c5e704-d69f-4388-b6b1-380084546404',
    //     //       'b333972c-15d9-4f3f-81db-7085b52f7666',
    //     //     ],
    //     //   },
    //     // },
    //     // {
    //     //   id: '',
    //     //   type: CatalogLookupType.product,
    //     //   targetEntityOperation: TargetEntityOperation.upsert,
    //     //   targetEntityType: TargetEntityType.composite,
    //     //   targetValue: {
    //     //     productGroupIds: [
    //     //       '2b2f3e71-cf8c-4024-8691-a2b41bda033c',
    //     //       '2541a0ac-2604-4934-bc1f-2ffd2909eb3e',
    //     //     ],
    //     //     productGroupContextData: [
    //     //       {
    //     //         productGroupId: '2b2f3e71-cf8c-4024-8691-a2b41bda033c',
    //     //         minimumRequired: 1,
    //     //         maximumAllowed: 1,
    //     //         defaultProductIds: [],
    //     //       },
    //     //       {
    //     //         productGroupId: '2541a0ac-2604-4934-bc1f-2ffd2909eb3e',
    //     //         minimumRequired: 1,
    //     //         maximumAllowed: 1,
    //     //         defaultProductIds: [],
    //     //       },
    //     //     ],
    //     //     compositeType: 'BUNDLE',
    //     //   },
    //     // },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: {
    //         calories: '123',
    //         caloricCountInput: {
    //           caloricUnit: 'cal',
    //           lowerRange: 120,
    //           higherRange: 200,
    //           servings: 1,
    //         },
    //       },
    //       targetEntityType: TargetEntityType.product,
    //       targetField: 'calories',
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: {
    //         value: '120',
    //         unit: 'mgm',
    //       },
    //       targetEntityType: TargetEntityType.product,
    //       targetField: 'sodium',
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: 'New Image',
    //       targetEntityType: TargetEntityType.decorator,
    //       targetField: 'images',
    //       targetKey: 'consumer-api',
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: 'New Name Innit',
    //       targetEntityType: TargetEntityType.decorator,
    //       targetField: 'title',
    //       targetKey: 'en-GB',
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: 'New Description Innit',
    //       targetEntityType: TargetEntityType.product,
    //       targetField: 'description',
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: {
    //         description: 'New Upsell',
    //         catalogEntryIds: ['9e594f02-0438-4cfd-9fa8-891e5f9f8d43'],
    //       },
    //       targetEntityType: TargetEntityType.upsell,
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: 'New Title',
    //       targetEntityType: TargetEntityType.product,
    //       targetField: 'title',
    //     },
    //     {
    //       id: '',
    //       type: CatalogLookupType.product,
    //       targetEntityOperation: TargetEntityOperation.upsert,
    //       targetValue: 'New Name',
    //       targetEntityType: TargetEntityType.product,
    //       targetField: 'name',
    //     },
    //   ]);
    //   subscriber.complete();
    // });

    const URL = this.changesUrl
      .replace('{changeSetId}', changeSetId)
      .replace('{catalogEntryId}', catalogEntryId);

    return this.http.get(URL).pipe(
      map((response: CatalogChangesResponse) => {
        if (response && response._embedded) {
          return response._embedded.catalogChanges;
        }
      }),
    );
  }

  getAll(): Observable<ChangeSetItem[]> {
    const URL = this.serviceURL;

    return this.http.get(URL).pipe(
      map((response: ChangeSetsResponse) => {
        if (response && response._embedded) {
          return response._embedded.catalogChanges;
        }
      }),
    );
  }

  saveVersionItem(
    changeSetId,
    catalogEntryId,
    body: PatchCatalogChangesInput,
  ): Observable<PatchCatalogChangesResponse> {
    const URL = this.patchItemURL
      .replace('{changeSetId}', changeSetId)
      .replace('{catalogEntryId}', catalogEntryId);

    return this.http.patch(URL, body).pipe(
      map((response: PatchCatalogChangesResponse) => {
        return response;
      }),
      catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
    );
  }

  releaseChanges(changeSetId: string): Observable<ReleaseChangeSetResponse> {
    const URL = this.releaseSetUrl.replace('{changeSetId}', changeSetId);
    const BODY = {};

    return this.http.put(URL, BODY).pipe(
      map((response: ReleaseChangeSetResponse) => {
        return response;
      }),
      catchError((err: ngCommonHttp.HttpErrorResponse) => throwError(err)),
    );
  }

  getChangesList(changeSetId: string): Observable<ChangesListResponse> {
    const URL = this.allChangesUrl.replace('{changeSetId}', changeSetId);

    return this.http.get(URL).pipe(
      map((response: ChangesListResponse) => {
        if (response) {
          return OmitService.omit(response, '_links');
        }
      }),
    );
  }
}
